import DisplayLabel from './DisplayLabel'

export default DisplayLabel
